module.exports = __webpack_public_path__ + "static/media/featured.7753a55e.svg";